import moment from 'moment';
import api from '../../../../services/api';
import { normalizarCnpj, toDate } from '../../../../helpers/utils';
import { dateMask } from '../../../../helpers/helpersEditForm';

export const getRNTRCForm = (form, formProp, proprietarioCadastro) => {
  const RNTRC = [
    {
      label: 'RNTRC',
      nome: 'rntrc',
      width: '32%',
      initialValue: proprietarioCadastro?.rntrc || null,
    },
    {
      label: 'VALIDADE RNTRC',
      nome: 'validadeRNTRC',
      width: '32%',
      initialValue: proprietarioCadastro?.vencimentoRNTRC
        ? moment(proprietarioCadastro?.vencimentoRNTRC).format('DD/MM/YYYY')
        : null,
      onChange: e => dateMask(e.target.value, form, 'validadeRNTRC'),
    },
  ];
  return [...formProp, ...RNTRC];
};

export const getEnderecoForm = (formProp, dadosEndereco, listUF) => {
  const endereco = [
    {
      label: 'Endereço',
      nome: 'endereco',
      width: '98.7%',
      initialValue: dadosEndereco?.endereco || null,
    },
    {
      label: 'Número',
      nome: 'numero',
      width: '32%',
      initialValue: dadosEndereco?.numero || null,
    },
    {
      label: 'Complemento',
      nome: 'complemento',
      width: '32%',
      initialValue: dadosEndereco?.complemento || null,
    },
    {
      label: 'Bairro',
      nome: 'bairro',
      width: '32%',
      initialValue: dadosEndereco?.bairro || null,
    },
    {
      label: 'Cep',
      nome: 'cep',
      width: '32%',
      initialValue: dadosEndereco?.cep || null,
    },
    {
      firstId: 'ufEndereco',
      secondId: 'cidadeEndereco',
      select: 'double',
      nome: 'ufCidadeEndereco',
      firstLabel: 'UF',
      secondLabel: 'Município',
      firstInitialValue: dadosEndereco?.uf || null,
      width: '65%',
      secondInitialValue: dadosEndereco?.codigoIbgeMunicipio || null,
      list: listUF,
    },
  ];
  return [...formProp, ...endereco];
};

// Campos que nao existem nesta secao nao devem apagar o cadastro completo.
// Valores vazios/null enviados pelo formulario continuam sendo alteracoes.
const camposPreenchidosNoFormulario = campos =>
  Object.fromEntries(
    Object.entries(campos).filter(([, valor]) => valor !== undefined)
  );

export const getPayloadPFPJ = (dados, form, proprietario) => {
  const arrayCodigoIbgeENome = String(form.cidadeEndereco).split('#');
  let codigoIBGECidade = form.cidadeEndereco;
  let cidade = dados?.dadosEndereco?.nomeMunicipio;
  if (arrayCodigoIbgeENome.length === 2) {
    codigoIBGECidade = arrayCodigoIbgeENome[0];
    cidade = arrayCodigoIbgeENome[1];
  }

  let payload = {
    documento: dados?.pessoaFisicaCadastro?.cpf
      ? form.cpf.replace(/[^\d]+/g, '')
      : normalizarCnpj(form.cnpj),
    telefone: form.telefone === undefined ? dados?.telefone : form.telefone,
    idTipoCadastro: dados?.idTipoCadastro,
    referencias: dados?.referencias,
    proprietarioCadastro: dados?.proprietarioCadastro,
    dadosEndereco: {
      ...dados?.dadosEndereco,
      ...camposPreenchidosNoFormulario({
        codigoIbgeMunicipio: codigoIBGECidade,
        nomeMunicipio: cidade,
        endereco: form.endereco,
        numero: form.numero,
        complemento: form.complemento,
        uf: form.ufEndereco,
        bairro: form.bairro,
        cep: form.cep,
      }),
    },
  };

  const proprietarioCadastro = {
    ...dados?.proprietarioCadastro,
    ...camposPreenchidosNoFormulario({
      rntrc: form.rntrc,
      vencimentoRNTRC: toDate(form.validadeRNTRC),
    }),
  };

  if (proprietario) {
    payload = { ...payload, proprietarioCadastro };
  }

  if (dados?.pessoaFisicaCadastro?.cpf) {
    const naturalidadeCodigoENome = String(form.cidadeNascimentoFundacao).split(
      '#'
    );

    let ibgeCidadeNascimento = dados.pessoaFisicaCadastro.ibgeCidadeNascimento;
    let naturalidade = dados.pessoaFisicaCadastro.naturalidade;
    if (naturalidadeCodigoENome.length === 2) {
      ibgeCidadeNascimento = naturalidadeCodigoENome[0];
      naturalidade = naturalidadeCodigoENome[1];
    }

    const pessoaFisicaCadastro = {
      ...dados.pessoaFisicaCadastro,
      ...camposPreenchidosNoFormulario({
        cpf: form.cpf.replace(/[^\d]+/g, ''),
        nome: form.nome,
        nomeMae: form.nomeMae,
        nomePai: form.nomePai,
        ibgeCidadeNascimento,
        naturalidade,
        ufNascimento: form.ufNascimentoFundacao,
        numeroRG: form.numeroRG === undefined ? form.rg : form.numeroRG,
        ufrg: form.ufrg,
        dataNascimentoStr: form.nascimento,
        dataNascimento: toDate(form.nascimento),
        numeroPIS: form.numeroPIS,
      }),
    };

    return { ...payload, pessoaFisicaCadastro };
  }

  const pessoaJuridicaCadastro = {
    ...dados?.pessoaJuridicaCadastro,
    ...camposPreenchidosNoFormulario({
      cnpj: normalizarCnpj(form.cnpj),
      nomeFantasia: form.nomeFantasia,
      razaoSocial: form.razaoSocial,
      inscricaoEstadual: form.inscEstadual,
    }),
  };

  return { ...payload, pessoaJuridicaCadastro };
};

export const enviarDadosPessoa = async (
  setSpinning,
  carregarSolicitacaoAtual,
  setReadOnly,
  payload
) => {
  setSpinning(true);
  try {
    const response = await api.post('pessoa', payload);
    await carregarSolicitacaoAtual();
    setReadOnly(true);
    setSpinning(false);
    return response;
  } catch (error) {
    setSpinning(false);
    return error;
  }
};
